import {
    NumberInput as NI,
    type NumberInputEventHandler as NIEH,
    type PropsType,
} from '../src/NumberInput/index.tsx';

// working around an error with re-exporting the type:
// ("NumberInputEventHandler" not found in '../src/NumberInput')
export type NumberInputEventHandler = NIEH;
export const NumberInput = NI;
export type NumberInputProps = PropsType;
